<template>
    <v-row v-if="is_loading"
           style="height: calc(100vh - 80px);"
           class="fill-height"
           align-content="center"
           justify="center">
        <v-col cols="12" class="subtitle-1 text-center">
            {{loading_display_title}}
        </v-col>
        <v-col cols="6" lg="3">
            <v-progress-linear
                    color="cyan accent-4"
                    indeterminate
                    rounded
                    height="6"
            ></v-progress-linear>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "GettingDataOverlayComponent",

        props : {
            is_loading : {
                type: Boolean,
                required: true,
            },
            loading_display_title : {
                type: String,
                required : true
            }
        }

    }
</script>

<style scoped>

</style>